export const WHITEBOARDS = {
    CREATE_WHITEBOARD: "create-whiteboard",
    NAME: "whiteboard-name",
    PERMISSION: "whiteboard-permission",
    ROW: "whiteboard-row",
    BRAND: "whiteboard-brand",
    ACCESS: "whiteboard-access",
    DELETE: "whiteboard-delete",
};
